module.exports = __webpack_public_path__ + "img/eat_out_20.38ac6657.jpg";